import { render, staticRenderFns } from "./TodoList.vue?vue&type=template&id=7b979458&scoped=true&lang=pug&"
import script from "./TodoList.vue?vue&type=script&lang=js&"
export * from "./TodoList.vue?vue&type=script&lang=js&"
import style0 from "./TodoList.vue?vue&type=style&index=0&id=7b979458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b979458",
  null
  
)

component.options.__file = "TodoList.vue"
export default component.exports